import { mapActions } from 'vuex'
import { testNotification } from '@/services/api';
import { getSchedule } from '../views/notification/schedule';

import { notifier } from '@/shared/lib/notifier/index';

export const notificationSpeciMixin = {
    data() {
        return {
            specificationsDictionary: [],
            specificationsKeysDictionary: [],
        }
    },
    methods: {
        ...mapActions([
            'saveNotification',
            'updateNotification',
        ]),
        addSpiceVariable(text, speciName) {
            const replacementWords = this.specificationsDictionary.filter(speci => text.includes(`data-var-value="${speci}"`));
            let specification = this.specifications[speciName];
            replacementWords.forEach(word => {
                const specificationName = Object.keys(specification).find(key => specification[key].toUpperCase() === word.toUpperCase());
                const pattern = `<span contenteditable="false">${word}</span>`;
                const replacement = `<span contenteditable="false">${specificationName}</span>`;
                text = text.replaceAll(pattern, replacement);
            });

            return text;
        },
        replaceOnSpices(text, speciName) {
            text = this.addSpiceVariable(text, speciName);
            const replacementWords = this.specificationsDictionary.filter(speci => text.includes(`data-var-value="${speci}"`));
            let specification = this.specifications[speciName];
            replacementWords.forEach(word => {
                const specificationName = Object.keys(specification).find(key => specification[key].toUpperCase() === word.toUpperCase());
                // eslint-disable-next-line no-irregular-whitespace
                const pattern = `<span class="dx-variable" data-var-start-esc-char="" data-var-end-esc-char="" data-var-value="${word}">﻿<span contenteditable="false">${specificationName}</span>﻿</span>`;
                text = text.replaceAll(pattern, specificationName);
            });

            return text;
        },
        addSpiceWrapper(text, speciName) {
            const replacementWords = this.specificationsKeysDictionary.filter(s => text.includes(s));
            let specification = this.specifications[speciName];
            replacementWords.forEach(word => {
                const specificationName = specification[word];
                const replacement = `<span class="dx-variable" data-var-start-esc-char="" data-var-end-esc-char="" data-var-value="${specificationName}"><span contenteditable="false">${word}</span></span>`;
                text = text.replaceAll(word, replacement);
            });

            return text;
        },
        async save(test) {
            const error = await this.validateValues();
            if (!error)
                return;

            this.dataNotif.notification.schedule = await getSchedule(this.dataNotif.scheduleDetail, this.dataNotif.scheduleDetail.time);
            this.dataNotif.notification.notificationType = this.notificationTypes.find(type => this.dataNotif.notification.notificationType.code === type.code);

            try {
                this.saving = true;

                this.dataNotifSave = Object.assign({}, this.dataNotif.notification);
                this.dataNotifSave.body = this.replaceOnSpices(this.dataNotifSave.body, this.speciName);
        
                if (this.dataNotif.notification.id) {
                    await this.updateNotification({id: this.dataNotif.notification.id, data: this.dataNotifSave});
                    notifier.showSuccess(this.$t('general.updateSuccess'));
                } else {
                    await this.saveNotification(this.dataNotifSave);
                    notifier.showSuccess(this.$t('general.createSuccess'));
                    this.$router.replace({
                        name: "notification",
                        params: { id: this.getNotification.id, type: this.getNotification.notificationType.code }
                    })
                }

                if (test) {
                    await testNotification(this.getNotification.id);
                    notifier.showSuccess(this.$t('notification.testNotification'));
                }
            } catch(err) {
                this.onDataError(err);
            } finally {
                this.saving = false;
            }
        },
    },
};